import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { SlideDown } from "react-slidedown";
import { linkProps, linkTypes } from "../../../interfaces/interfaces";
import { Icon } from "@material-ui/core";

import styles from "./NavLinks.module.scss";

class NavLinks extends Component<linkProps> {
  state: linkProps & { activeSubMenu: string | undefined };

  constructor(props: linkProps) {
    super(props);
    this.state = { ...props, activeSubMenu: undefined };
    this.clickBehavior = this.clickBehavior.bind(this);
  }

  clickBehavior() {
    this.setState({ activeSubMenu: undefined });
    if (this.props.onClick) {
      this.props.onClick();
    }
  }

  toggleActiveSubMenu(e: React.MouseEvent, subMenu: string) {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopPropagation();
    if (subMenu == this.state.activeSubMenu) {
      this.setState({ activeSubMenu: undefined });
    } else {
      this.setState({ activeSubMenu: subMenu });
    }
  }

  componentDidUpdate() {
    if (this.props.closed && this.state.activeSubMenu) {
      this.setState({ activeSubMenu: undefined });
    }
  }

  render() {
    if (this.props.slideDownAnimation) {
      return (
        <SlideDown closed={this.props.closed} className={styles.slidedown}>
          {this.links()}
        </SlideDown>
      );
    } else {
      return this.links();
    }
  }

  links() {
    return (
      <ul
        className={`${styles.ul} ${styles[this.props.displayStyle]}`}
        onClick={this.clickBehavior.bind(this)}
      >
        <li className={`${styles.li} ${styles.footerHidden}`}>
          <NavLink
            exact={true}
            to="/"
            className={styles.a}
            activeStyle={{ color: this.props.activeColor }}
          >
            HOME
          </NavLink>
        </li>
        <li className={styles.li}>
          <NavLink
            to="/about-us"
            className={styles.a}
            activeStyle={{ color: this.props.activeColor }}
          >
            ABOUT US
          </NavLink>
          <ul className={`${styles.footerOnly} ${styles.sublist}`}>
            <li className={styles.sublist_li}>
              <span className={styles.sublistText}>
                Quality Servcie Since 1999
              </span>
            </li>
            <li className={styles.sublist_li}>
              <span className={styles.sublistText}>
                5 Million lbs. Annual Capacity
              </span>
            </li>
            <li className={styles.sublist_li}>
              <span className={styles.sublistText}>
                Convienent Mid-Atlantic Location
              </span>
            </li>
            <li className={styles.sublist_li}>
              <NavLink
                to="/about-us"
                className={`${styles.sublist_a} ${styles.sublist_a_underline}`}
              >
                Learn more about us
              </NavLink>
            </li>
          </ul>
        </li>
        <li className={styles.li}>
          <NavLink
            exact={true}
            to="/manufacturing-capabilities"
            className={`${styles.a} ${
              this.state.activeSubMenu == "manufacturing"
                ? styles.activeSubmenu
                : undefined
            }`}
            activeStyle={{ color: this.props.activeColor }}
          >
            MANUFACTURING CAPABILITIES
            <div
              className={styles.mobileNavIconContainer}
              onClick={e => this.toggleActiveSubMenu(e, "manufacturing")}
            >
              <Icon className={styles.mobileNavIcons}>
                {this.props.displayStyle == linkTypes.mobile &&
                this.state.activeSubMenu != "manufacturing"
                  ? "expand_more"
                  : "expand_less"}
              </Icon>
            </div>
          </NavLink>

          <SlideDown
            className={styles.slidedown}
            closed={
              this.props.displayStyle == linkTypes.mobile &&
              this.state.activeSubMenu != "manufacturing"
            }
            transitionOnAppear={false}
          >
            <ul
              className={`${styles.sublist} ${
                styles[this.props.isSticky ? "sticky" : ""]
              }`}
            >
              <li className={styles.sublist_li}>
                <NavLink
                  exact={true}
                  to="/manufacturing-capabilities/pulverizing"
                  className={styles.sublist_a}
                >
                  Pulverizing
                </NavLink>
              </li>
              <li className={styles.sublist_li}>
                <NavLink
                  exact={true}
                  to="/manufacturing-capabilities/screening"
                  className={styles.sublist_a}
                >
                  Screening
                </NavLink>
              </li>
              <li className={styles.sublist_li}>
                <NavLink
                  exact={true}
                  to="/manufacturing-capabilities/blending"
                  className={styles.sublist_a}
                >
                  Blending
                </NavLink>
              </li>
              <li className={styles.sublist_li}>
                <NavLink
                  exact={true}
                  to="/manufacturing-capabilities/repackaging"
                  className={styles.sublist_a}
                >
                  Repackaging
                </NavLink>
              </li>
            </ul>
          </SlideDown>
        </li>
        <li className={styles.li}>
          <NavLink
            to="/contact-us"
            className={styles.a}
            activeStyle={{ color: this.props.activeColor }}
          >
            CONTACT US
          </NavLink>

          <ul className={`${styles.footerOnly} ${styles.sublist}`}>
            <li className={styles.sublist_li}>
              <Icon className={styles.sublistIcons}>phone</Icon>
              <span className={styles.sublistText}>
                215-230-3324 x100 (all inquiries)
              </span>
            </li>
            <li className={styles.sublist_li}>
              <Icon className={styles.sublistIcons}>print</Icon>
              <span className={styles.sublistText}>215-230-3328</span>
            </li>
            <li className={styles.sublist_li} id={styles.email}>
              <Icon className={styles.sublistIcons}>email</Icon>
              <span className={styles.sublistText}>
                michael.austin@powdersolutions.com
              </span>
            </li>
            <li className={styles.sublist_li}>
              <Icon className={styles.sublistIcons}>place</Icon>
              <span className={styles.sublistText}>
                98 Spring Lake Drive New Britain, PA 18901
              </span>
            </li>
          </ul>
        </li>
      </ul>
    );
  }
}

export default NavLinks;
